<template>
  <div class="view-gabarit">
    <h2 class="head-box-title">{{ $t('createANewStudy') }}</h2>
    <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    <VeeForm v-slot="{ errors }" @submit="submitForm">
      <fieldset>
        <label for="studyName">{{ $t('studyName') }}</label>
        <Field v-slot="{ field, errors }" rules="required|max:64" :label="$t('studyName')" name="studyName">
          <input v-bind="field" :class="{ 'has-error': errors.length > 0 }" type="text" :placeholder="$t('studyName')" />
          <span v-if="field.value?.length > 64" class="error-caption">{{ $t('studyNameTooLong') }}</span>
          <span v-else-if="errors.length > 0" class="error-caption">{{ errors[0] }}</span>
        </Field>
      </fieldset>
      <fieldset>
        <label for="clientName">{{ $t('clientName') }}</label>
        <Field
          :class="{ 'has-error': errors.clientName }"
          rules="required"
          name="clientName"
          type="text"
          :placeholder="$t('clientName')"
          :label="$t('clientName')"
        />
        <ErrorMessage name="clientName" class="error-caption" />
      </fieldset>
      <fieldset>
        <label for="clientLogo">{{ $t('clientLogo') }}</label>
        <div class="logo-container" :class="{ dragging: dragging, filled: logo }">
          <input
            v-if="!logo"
            name="clientLogo"
            type="file"
            class="logo-input"
            :placeholder="$t('clientLogo')"
            @change="uploadLogo($event.target.files)"
            @dragenter="dragging = true"
            @dragend="dragging = false"
            @dragleave="dragging = false"
          />
          <div v-else class="logo" :style="{ backgroundImage: `url(${logoUrl})` }"></div>
          <div v-if="!logo" class="label-input">
            {{ $t('dargAndDropLogo') }}
            <div class="select">
              {{ $t('chooseFile') }}
            </div>
          </div>
          <div v-if="logo" class="delete-button" @click="deleteLogo">×</div>
        </div>
      </fieldset>
      <fieldset>
        <button class="study-button main" type="submit">
          {{ $t('continue') }}
        </button>
        <button class="study-button secondary" @click.prevent.stop="() => $emit('closeModal')">
          {{ $t('cancel') }}
        </button>
      </fieldset>
    </VeeForm>
  </div>
</template>

<script>
import { ErrorMessage, Field, Form as VeeForm } from 'vee-validate';

export default {
  components: {
    ErrorMessage,
    Field,
    VeeForm,
  },

  data() {
    return {
      dragging: false,
      errorMessage: null,
      loading: false,
      logo: null,
      logoUrl: null,
    };
  },

  methods: {
    submitForm(values) {
      this.errorMessage = null;

      const { studyName, clientName } = values;

      this.$store
        .dispatch('createStudy', { studyName, clientName })
        .then(result => {
          if (this.logo) {
            this.$store.dispatch('uploadLogo', { id: result.public_id, file: this.logo }).then(() => {
              this.$router.push({ name: 'studyUploadCSV', params: { studyId: result.public_id } });
            });
          } else {
            this.$router.push({ name: 'studyUploadCSV', params: { studyId: result.public_id } });
          }
        })
        .catch(e => {
          console.dir(e);
          console.log(e.response.status);

          this.errorMessage = 'Error';
          if (e.response.status === 409) {
            this.errorMessage = this.$t('errorMessage.studyNameAlreadyExists');
          }
        });
    },

    uploadLogo(files) {
      this.error = false;

      if (files.length <= 0) {
        return;
      }

      this.dragging = false;
      this.logo = files[0];

      const reader = new FileReader();

      reader.addEventListener(
        'load',
        () => {
          this.logoUrl = reader.result;
        },
        false,
      );

      if (this.logo) {
        reader.readAsDataURL(this.logo);
      }
    },

    deleteLogo() {
      this.loading = false;
      this.logo = null;
      this.logoUrl = null;
    },
  },
};
</script>

<style lang="scss">
@use '@/styles/colors.scss';

.view-gabarit {
  .logo-container {
    position: relative;
    width: 100%;
    height: 96px;

    border: dashed 2px #e8e7e6;

    color: #3c3c3b;
    font-size: 14px;
    border-radius: 2px;

    transition: all 0.3s ease;

    &:not(.filled):hover {
      border-color: colors.$main-color;
    }

    .logo-input {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      opacity: 0;

      cursor: pointer;
    }

    .label-input {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .select {
        font-weight: bold;
        color: colors.$main-color;
        margin: 4px 0 0;
      }
    }

    .logo {
      width: 100%;
      height: 100%;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }

    .delete-button {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 2px;
      right: 2px;
      width: 16px;
      height: 16px;
      border-radius: 24px;
      background: rgba(#e3e3e3, 0.6);
      // transform: rotate(45deg);
      cursor: pointer;

      transition: 0.3s ease-out;

      &:hover {
        background: #e3e3e3;
      }
    }
  }
}

.error-message {
  width: 320px;
  margin: 0 0 16px;
  font-size: 14px;
  text-align: center;
  color: colors.$red-color;
}
</style>
